function waitForJQuery() {
    if (window.jQuery) {
        loadFiles();
    } else {
        setTimeout(waitForJQuery, 20);
    }
}

function loadFiles() {
    require('./jquery/jquery.accordeonPlugin.js');
    require('./jquery/jquery.accordeonSimple.js');
    require('./jquery/jquery.autocomplete.js');
    require('./jquery/jquery.co2Plugin.js');
    require('./jquery/jquery.contactUsPlugin.js');
    require('./jquery/jquery.cookiePlugin.js');
    require('./jquery/jquery.countryNavPlugin.js');
    require('./jquery/jquery.dmsTablePlugin.js');
    require('./jquery/jquery.evenDigitCheckPlugin.js');
    require('./jquery/jquery.eventMove.js');
    require('./jquery/jquery.eventSwipe.js');
    require('./jquery/jquery.eventsHandlerPlugin.js');
    require('./jquery/jquery.fadeInTeaserPlugin.js');
    require('./jquery/jquery.fessSearchResultsPlugin.js');
    require('./jquery/jquery.gallery2Plugin.js');
    require('./jquery/jquery.headerPlugin.js');
    require('./jquery/jquery.hoverIntent.js');
    require('./jquery/jquery.hyperlinkIcons.js');
    require('./jquery/jquery.i18nPlugin.js');
    require('./jquery/jquery.iframeOverlayPlugin.js');
    require('./jquery/jquery.imageMapPlugin.js');
    require('./jquery/jquery.imgVisualCenterPlugin.js');
    require('./jquery/jquery.immoFilterPlugin.js');
    require('./jquery/jquery.langDdNavPlugin.js');
    require('./jquery/jquery.lazyLoadFramesPlugin.js');
    require('./jquery/jquery.lazyLoadImagesPlugin.js');
    require('./jquery/jquery.mashupPlugin.js');
    require('./jquery/jquery.mashupSocialMediaCheckPlugin.js');
    require('./jquery/jquery.offcanvasPlugin.js');
    require('./jquery/jquery.panoramaImagesPlugin.js');
    require('./jquery/jquery.piwikPlugin.js');
    require('./jquery/jquery.popoverPlugin.js');
    require('./jquery/jquery.previewSliderPlugin.js');
    require('./jquery/jquery.quizPlugin.js');
    require('./jquery/jquery.readmorePlugin.js');
    require('./jquery/jquery.scrollClassesPlugin.js');
    require('./jquery/jquery.serviceNavPlugin.js');
    require('./jquery/jquery.siteimproveWidgetPlugin.js');
    require('./jquery/jquery.sliderPlugin.js');
    require('./jquery/jquery.stoerungsmeldungenPlugin.js');
    require('./jquery/jquery.tableDivisionPlugin.js');
    require('./jquery/jquery.tableFilterPlugin.js');
    require('./jquery/jquery.tablesorter.js');
    require('./jquery/jquery.tabsPlugin.js');
    require('./jquery/jquery.videoDisclaimerPlugin.js');
    require('./jquery/jquery.videoPreviewPlugin.js');
    require('./jquery/jquery.waterfallPlugin.js');
    require('./jquery/jquery.waterfallVideosDisclaimerPlugin.js');
    require('./jquery/jquery.webcamPlugin.js');
    require('./jquery/jquery.xparallaxPlugin.js');
    require('./jquery/lightslider.js');
    require('./jquery/main.js');
}

waitForJQuery();
